export default "__VITE_ASSET__5FFWP2zX__"